module.exports = __webpack_public_path__ + "static/dc05717b-6e27-4ca4-a8d0-b245cc20f111-6ad4893e5128229f85842448fbe0e233.webp";